import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import home from '@/views/AdminSys/Admin.vue'
import { createRouter, creatememoryHistory } from "vue-router"

Vue.use(VueRouter)


async function nemu (){
  let num2 = await home.methods.MenuRouters();
  return num2
}
const Menu = await nemu()

const router = new VueRouter({
  mode: 'history',
  routes: [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),

  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminSys/Admin.vue'),
    children: Menu,
    meta: {
      requiresAuth: true
    }
  },
]
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = Cookies.get('token')
  if (to.path=='/login'){
    if (token){
      next('/admin') 
    }else{
      next()
    }
  }else if(token) {
    if (to.path == '/admin') {
      next(Menu[0]['path']) 
    } else if (to.path=='/') {
      next(Menu[0]['path']) 
    }
    next()
  } else {
    next('/login')
  }
});

export default router;
